// Access / Security Auditor API client (admin). One GET probes every connection
// server-side (bounded-parallel) and returns per-connection account risk.
import { api } from './api.js';

// → { connections: [{ connId, name, groupName, color, reachable, error?,
//      privError?, server?, risky: [{user,host,locked,findings,maxSeverity}],
//      cleanCount, counts: {high,medium,low} }], probedAt }
export const probeAccessAudit = () => api.get('/api/tools/access-audit');
